import './css/VideoSection.css'
import NavBar from './homeComponents/NavBar';
import Footer from './homeComponents/Footer';
import ComingSoon from './comingSoonComponent/ComingSoon';
import PayAhead from './scheduleComponents/PayAhead';
import { useLayoutEffect } from 'react';

export default function Schedule() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
});
  return (
    <div>
        <NavBar />
        <PayAhead />
        <Footer />
    </div>
  );
}